import { useState } from "react";

import estilos from "./Login.module.css";

interface Props {
  cargando: boolean;
  error: string | null;
  onIniciarSesion: (email: string, password: string) => Promise<void>;
  onRegistrar: (email: string, password: string) => Promise<void>;
}

type Modo = "login" | "registro";

const LONGITUD_MIN_PASSWORD = 8;

// Pantalla bloqueante de login/registro (adapta GuardiaToken del hermano,
// que pedia un ADMIN_TOKEN unico, a cuentas reales por email + contrasena).
export function Login({
  cargando,
  error,
  onIniciarSesion,
  onRegistrar,
}: Props): JSX.Element {
  const [modo, setModo] = useState<Modo>("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const enviar = async (
    evento: React.FormEvent<HTMLFormElement>,
  ): Promise<void> => {
    evento.preventDefault();
    try {
      if (modo === "login") {
        await onIniciarSesion(email, password);
      } else {
        await onRegistrar(email, password);
      }
    } catch {
      // El error ya queda expuesto via la prop `error`.
    }
  };

  return (
    <div className={estilos.overlay}>
      <div className={estilos.tarjeta}>
        <h1 className={estilos.titulo}>Super Marketing</h1>
        <p className={estilos.subtitulo}>
          Generador agentico de flyers editables.
        </p>

        <div
          className={estilos.tabs}
          role="tablist"
          aria-label="Modo de acceso"
        >
          <button
            type="button"
            role="tab"
            aria-selected={modo === "login"}
            className={`${estilos.tab} ${modo === "login" ? estilos.tabActivo : ""}`}
            onClick={() => setModo("login")}
            disabled={cargando}
          >
            Iniciar sesion
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={modo === "registro"}
            className={`${estilos.tab} ${modo === "registro" ? estilos.tabActivo : ""}`}
            onClick={() => setModo("registro")}
            disabled={cargando}
          >
            Crear cuenta
          </button>
        </div>

        <form onSubmit={enviar} noValidate>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={cargando}
          />

          <label htmlFor="password">Contrasena</label>
          <input
            id="password"
            type="password"
            autoComplete={
              modo === "login" ? "current-password" : "new-password"
            }
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={modo === "registro" ? LONGITUD_MIN_PASSWORD : undefined}
            required
            disabled={cargando}
          />
          {modo === "registro" && (
            <p className={estilos.ayuda}>
              Minimo {LONGITUD_MIN_PASSWORD} caracteres.
            </p>
          )}

          {error && (
            <p className={estilos.error} role="alert">
              {error}
            </p>
          )}

          <div className={estilos.acciones}>
            <button
              type="submit"
              className="boton boton-primario boton-grande"
              disabled={cargando}
            >
              {cargando
                ? "Un momento..."
                : modo === "login"
                  ? "Iniciar sesion"
                  : "Crear cuenta"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
